import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsDepartmentReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsDepartmentReducer;
